import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PublicLayout from '../../layouts/PublicLayout';
import AuthStep from '../../components/public/AuthStep';
import BookingWizard from '../../components/public/BookingWizard';

const PublicScheduling = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const phone = searchParams.get('phone');

    // If phone is present, show Wizard. If not, show AuthStep (Phone Input).
    // The previous plan said AuthStep redirects.

    return (
        <PublicLayout>
            {!phone ? (
                <AuthStep />
            ) : (
                <BookingWizard phone={phone} />
            )}
        </PublicLayout>
    );
};

export default PublicScheduling;
